"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { EPORNER_CATEGORIES } from "@/lib/eporner-categories"
import { useTranslations } from "next-intl"

export const EPORNER_STRIP_ORDERS = ["latest", "most-popular", "top-weekly", "top-monthly", "top-rated", "longest", "shortest"] as const
export const EPORNER_STRIP_ORIENTATIONS = ["straight", "all", "gay"] as const

export type EpornerOrder = (typeof EPORNER_STRIP_ORDERS)[number]
export type EpornerOrientation = (typeof EPORNER_STRIP_ORIENTATIONS)[number]

interface EpornerFilterTabsProps {
  order: EpornerOrder
  orientation: EpornerOrientation
  category: string
  onOrderChange: (value: EpornerOrder) => void
  onOrientationChange: (value: EpornerOrientation) => void
  onCategoryChange: (value: string) => void
}

// EpornerVR's options: a category (searched as its word, the API has no category option), and the API's real `order` and `gay`.
export function EpornerFilterTabs({ order, orientation, category, onOrderChange, onOrientationChange, onCategoryChange }: EpornerFilterTabsProps) {
  const t = useTranslations("epornerFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[
        { id: "category", label: t("category"), value: category, defaultValue: "all", options: [{ value: "all", label: t("allCategories") }, ...EPORNER_CATEGORIES.map((c) => ({ value: c.slug, label: c.label }))] },
        { id: "order", label: t("order"), value: order, defaultValue: "latest", options: EPORNER_STRIP_ORDERS.map((value) => ({ value, label: t(value) })) },
        { id: "orientation", label: t("orientation"), value: orientation, defaultValue: "straight", options: EPORNER_STRIP_ORIENTATIONS.map((value) => ({ value, label: t(value) })) },
      ]}
      onChange={(id, value) => (id === "category" ? onCategoryChange(value) : id === "order" ? onOrderChange(value as EpornerOrder) : onOrientationChange(value as EpornerOrientation))}
    />
  )
}
